<template>
  <div>
    <Encabeza>

    </Encabeza>
    <v-card class="mx-10 my-5">
      <v-sheet class="my-3">
        <!-- <v-btn rounded variant="elevated" color="cyan-darken-1" @click="newForm()"><v-icon -->
   <v-card class="mx-auto my-3" max-width="100%" elevation="10">
      <v-sheet max-width="350" class="mx-left pa-3">
        <v-form @submit.prevent>
          <div class="row">
            <div class="col">
              <input
                v-model="fecha_inicio"
                type="date"
                class="form-control"
                aria-label="fecha_inicio"
              />
            </div>
            <div class="col mt-2">
              <input
                v-model="fecha_fin"
                type="date"
                class="form-control"
                aria-label="fecha_fin"
              />
            </div>
          </div>

          <v-btn
            @click="buscarPorFechas"
            append-icon="mdi-magnify"
            type="submit"
            color="blue-darken-4"
            block
            class="mt-2 font-weight-bold"
            >CONSULTAR</v-btn
          >
        </v-form>
      </v-sheet>
    </v-card>
       <v-btn        
          variant="elevated"
          color="blue-darken-4"
          @click="newForm()"
          ><v-icon icon="mdi-pencil-plus"></v-icon>&nbsp;Nuevo</v-btn
        >
      <center>  <v-btn
            rounded
            variant="elevated"
            color="red-darken-1"
            @click="generarPDF()"
            
            ><v-icon icon="mdi-file-pdf-box"></v-icon>&nbsp;REPORTE PDF</v-btn
          >  </center>  
      </v-sheet>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar registros"
        single-line
        hide-details
        color="blue-lighten-2"
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="registroslista"
        :search="search"
        :items-per-page-options="items_per_page_options"
        class="mt-1"
        :hover="true"
        :fixed-header="true"
        :height="500"
        :show-current-page="true"
        :loading="change_table"
        :items-per-page-text="$t('$vuetify.dataTable.itemsPerPageText')"
        :no-data-text="$t('$vuetify.dataTable.noDataText')"
        page-text="{0}-{1} de {2}"
      >
        <template v-slot:top>
          <FormArmasPage
            :dialog_parent="dialog_form"
            :registro_parent="item_armas_plus"
            @closeDialogParent="closeDialogForm()"
            :formTitleParent="formTitle"
            @saveParent="save()"
            :errors_validate_parent="errors_validate"
          >
          </FormArmasPage>
          <FormArmasEditPage
            :dialog_parent="dialog_edit_form"
            :registro_parent="item_armas_plus"
            @closeDialogParent="closeDialogForm()"
            :formTitleParent="formTitle"
            @saveParent="update()"
            :errors_validate_parent="errors_validate"
          >
          </FormArmasEditPage>
          <v-snackbar
            v-model="snackbar_registers_enabled"
            :timeout="1000"
            location="top"
            min-height="70"
            :color="snackbar_color"
          >
            <p>{{ snackbar_registers_message }}</p>
          </v-snackbar>

          <v-dialog v-model="dialog_delete" max-width="500px" persistent>
            <v-card>
              <v-card-text class="text-center">
                <v-icon
                  class="as-scale"
                  icon="mdi mdi-delete"
                  size="100"
                  color="red"
                ></v-icon>
              </v-card-text>
              <p class="text-h4 text-center">
                ¿Esta seguro de eliminar este registro?
              </p>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  variant="elevated"
                  @click="closeDialogDelete()">
                  <v-icon icon="mdi-file-cancel-outline"></v-icon
                  >&nbsp;Cancelar</v-btn>

                <v-btn
                  color="cyan-darken-3"
                  variant="elevated"
                  @click="deleteConfirm()">

                  <v-icon icon="mdi-content-save-check-outline"></v-icon
                  >&nbsp;OK
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>

          </v-dialog>



          
        </template>
        <!-- <template v-slot:[`item.tipo`]="{ item }">
        <v-btn small rounded color="green" >{{ item.tipo }}</v-btn>
      </template> -->
        <!-- <template v-slot:[`item.status`]="{ item }">
          <v-icon :color="item.status ? 'green' : 'red'" :icon="item.status ? 'mdi-check-circle' : 'mdi-close-circle'"></v-icon>
        </template> -->

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            @click="abrirDialogo(item)"
            class="m-1"
            color="orange-darken-2"
            icon="mdi-eye"
          >
          </v-icon>
          <v-icon
            @click="editForm(item)"
            class="m-1"
            color="blue-darken-2"
            icon="mdi-pencil"
          >
          </v-icon>
          <v-icon
            @click="deleteItem(item)"
            color="red"
            class="m-1"
            icon="mdi-delete"
          >
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="success" @click="search = ''"> Reseter </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogoAbierto" max-width="500px">
                <!--           <template v-slot:activator="{ on }">
            <v-btn text v-on="on"> </v-btn>
          </template> -->
                <v-card>
                  <v-card-title> Contenido Individual </v-card-title>
                  <v-card-text>
                    <div><strong>ID: </strong> {{ id_arma }}</div>
                    <div><strong>CODIGO: </strong> {{ codigo_arma }}</div>
                    <div><strong>TIPO ARMA: </strong> {{ tipo }}</div>
                    <div><strong>MARCA: </strong> {{ marca_arma }}</div>
                    <div><strong>MODELO: </strong> {{ modelo_arma }}</div>
                    <div><strong>CALIBRE: </strong> {{ codigo_calibre }}</div>
                    <div><strong>CANT. CARGADORES: </strong> {{ cantidad_cargadores }}</div>
                    <div><strong>PROCEDENCIA: </strong> {{ codigo_procedencia }}</div>
                    <div><strong>CLASIFICACION: </strong> {{ codigo_clasificacion }}</div>
                    <div><strong>OBSERVACIONES: </strong> {{ observaciones }}</div>
                    <!-- <div><strong>ESTADO: </strong> {{ status }}</div> -->
                    <div>
                      <strong>ESTADO: </strong>
                      <span v-if="status">
                        <!-- Mostrar el icono de "bien" -->
                        <v-icon color="green">mdi-check-circle</v-icon>
                      </span>
                      <span v-else>
                        <!-- Mostrar el icono de "x" -->
                        <v-icon color="red">mdi-close-circle</v-icon>
                      </span>
                    </div>
                    <!-- Agrega aquí más campos con las variables que deseas mostrar -->
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
  </div>
</template>
<script>
import pdfMake from "pdfmake/build/pdfmake";

import { VDataTable } from "vuetify/labs/VDataTable";
import { defineComponent } from "vue";
import FormArmasPage from "@/components/armas/FormArmasPage.vue";
import FormArmasEditPage from "@/components/armas/FormArmasEditPage.vue";
//import PersonaNatural from "@/services/PersonaNatural";
import Armasplus from "@/services/Armas";
import Encabeza from '@/components/EncabezadoPage.vue';
import ReportesRegistro from "@/services/Reportes";

export default defineComponent({
  components: {
    VDataTable,
    FormArmasPage,
    FormArmasEditPage,
    Encabeza,
    
  },
  
  data() {
    const change_table = null;
    const obj_armas = new Armasplus();
    const datos = [];
    const items_per_page_options = [
      { value: 10, title: "10" },
      { value: 25, title: "25" },
      { value: 50, title: "50" },
      { value: 100, title: "100" },
    ];
    const headers = [
      { title: "#", key: "id_arma" },
      { title: "Codigo", key: "codigo_arma" },
      { title: "Tipo", key: "tipo" },
      { title: "Marca", key: "marca_arma" },
      { title: "Modelo", key: "modelo_arma" },
      { title: "Calibre", key: "codigo_calibre" },
      { title: "Cargadores", key: "cantidad_cargadores" },
      { title: "Procedencia", key: "codigo_procedencia" },
      { title: "Clasificación", key: "codigo_clasificacion" },
      { title: "Observaciones", key: "observaciones" },
      { title: "Estado", key: "status" },
      { title: "Acciones", key: "actions", sortable: true, width: 150 },
    ];
    const default_item = {
      id_arma: "",
      codigo_tipo: "",
      marca_arma: "",
      modelo_arma: "",
      codigo_calibre: "",
      cantidad_cargadores: "",
      codigo_procedencia: "",
      codigo_clasificacion: "",
      observaciones: "",
      status: "OPERABLE",
    };
    const item_armas_plus = default_item;
    const snackbar_registers_enabled = false;
    const snackbar_registers_message = "";
    const snackbar_color = "";
    const errors_validate = {};
    return {
      reportes: new ReportesRegistro(),
      datos,
      registroslista: [],
      obj_armas,
      change_table,
      dialog_form: false,
      dialog_edit_form: false,
      dialog_delete: false,
      search: "",
      valorCampo3: "",
      headers,
      index_array: -1,
      item_armas_plus,
      default_item,
      items_per_page_options,
      snackbar_registers_enabled,
      snackbar_registers_message,
      snackbar_color,
        errors_validate,
      dialogoAbierto: false,
    };
  },

  computed: {
    formTitle() {
      return this.index_array === -1 ? "Nuevo registro" : "Editar registro";
    },
  },

  mounted() {
    this.registros();
  },

  methods: {

         convertirImagenDataURL(imagen) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
  
          // Cargar la imagen como un Blob
          fetch(imagen)
            .then(response => response.blob())
            .then(blob => {
              reader.readAsDataURL(blob); // Convertir la imagen en una URL de datos
            })
            .catch(error => {
              reject(error);
            });
        });
      },

    abrirDialogo(item) {
      if (item && item.id_arma) {
        this.id_arma = item.id_arma;
        this.codigo_arma = item.codigo_arma;
        this.tipo = item.tipo;
        this.marca_arma = item.marca_arma;
        this.modelo_arma = item.modelo_arma;
        this.codigo_calibre = item.codigo_calibre;
        this.cantidad_cargadores = item.cantidad_cargadores;
        this.codigo_procedencia = item.codigo_procedencia;
        this.codigo_clasificacion = item.codigo_clasificacion;
        this.observaciones = item.observaciones;
        this.status = item.status;
        this.dialogoAbierto = true;
      }
      },
    cerrarDialogo() {
            this.dialogoAbierto = false;
        },
    registros() {
      this.change_table = "cyan";
      setTimeout(async () => {
        const response = await this.obj_armas.listadearmas();
        console.log(response);
        this.datos = response.records;
        if (response.status) {
          this.datos = response.records;
        } else {
          console.error("Respuesta inválida o sin registros.");
        }
        this.change_table = null;
      }, 1000);
    },
    editForm(item) {
      this.index_array = this.datos.indexOf(item);
      this.item_armas_plus = Object.assign({}, item);
      this.dialog_edit_form = true;
    },
    deleteItem(item) {
      if (item && typeof item.id_arma !== "undefined") {
        // Ahora puedes acceder a item.id de forma segura
        this.index_array = this.datos.indexOf(item);
        this.item_armas_plus = item;
        this.dialog_delete = true;
      } else {
        console.error("El registro no tiene un ID válido.");
      }
    },

    async deleteConfirm() {
      const armas_async = new Armasplus();
      console.log("ID a eliminar:", this.item_armas_plus.id_arma); // Agregar esta línea para depurar
      const response = await armas_async.deleteRegistroArmaIndividual(
        this.item_armas_plus.id_arma
      );
      console.log("Respuesta de la eliminación:", response);
      if (response.status) {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = "cyan-darken-3";
        this.snackbar_registers_message = response.message;
        this.datos.splice(this.index_array, 1);
      } else {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = "red";
        this.snackbar_registers_message = "Error interno del servidor";
      }

      this.closeDialogDelete();
    },
    closeDialogDelete() {
      this.dialog_delete = false;
      this.clear();
    },
    closeDialogForm() {
      this.dialog_form = false;
      this.dialog_edit_form = false;
      this.clear();
      this.registros();
    },
    clear() {
      this.$nextTick(() => {
        this.item_armas_plus = Object.assign({}, this.default_item);
        this.index_array = -1;
      });
      this.errors_validate = {};
    },

    newForm() {
      this.item_armas_plus = Object.assign({}, this.default_item);
      this.dialog_form = true;
      //this.dialog_edit_form = true;
    },
    async save() {
      const armas_async = new Armasplus();
      if (this.item_armas_plus.id > 0) {
        Object.assign(this.datos[this.index_array], this.item_armas_plus);
        const response = await armas_async.registroarmasput(
          this.item_armas_plus
        );
        if (response.status) {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_message = response.message;
          this.closeDialogForm();
        } else {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "red";
          if (response.validate_errors) {
            this.errors_validate = response.message_errors;
            this.snackbar_registers_message = response.message;
          } else {
            this.snackbar_registers_message = "Error interno en el servidor";
          }
        }
      } else {
        const response = await armas_async.saveData(this.item_armas_plus);
        console.log("Este es el response", response);
        if (response.status) {
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
          this.closeDialogForm();
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;
        }
      }
    },
    async update() {
      try {
        const armas_async = new Armasplus();
        const response = await armas_async.registroarmasput(
          this.item_armas_plus
        );
        console.log("Este es el response", response);

        if (response.status) {
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
          this.closeDialogForm();
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;
        }
      } catch (error) {
        console.error("Error al actualizar el registro:", error);
        // Aquí puedes manejar el error, mostrar un mensaje de error al usuario, etc.
      }
    },
    async buscarPorFechas() {
      try {
        this.registroslista = await this.reportes.buscarPorFechasPistolas(
          this.fecha_inicio,
          this.fecha_fin
        );
      } catch (error) {
        console.error("Error al buscar por fechas:", error);
        throw error;
      }
    },

     async generarPDF() {
      // Verificar si hay datos para generar el PDF
      if (this.registroslista.length === 0) {
        alert("No hay datos para generar el PDF");
        return;
      }

      // Cargar la imagen como un recurso
      const imagenRecurso = await import("@/assets/images/mindef.jpg");

      // Convertir la imagen en una URL de datos
      const imagenDataURL = await this.convertirImagenDataURL(
        imagenRecurso.default
      );

      // Mapear los registros a un formato adecuado para pdfMake
      const pdfRows = this.registroslista.map((item, index) => {
        return [

          index + 1, // Añade numeración ascendente, comenzando en 1
          item.codigo_arma || "",
          item.marca_arma || "",
          item.modelo_arma || "",
          item.codigo_calibre || "",
          item.cantidad_cargadores  || "",
          item.codigo_procedencia  || "",
          item.codigo_clasificacion  || "",
          item.observaciones  || "",
        
        ];
      });
      const currentDate = new Date();
      const formattedDate = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).format(currentDate);

      const fechaHora = `FECHA: ${formattedDate}`;
      // Definir la estructura del documento PDF
      const documentDefinition = {
        content: [
          //IMAGEN CABECERA
          {
            image: imagenDataURL, // Usar la URL de datos de la imagen
            width: 200, // ajusta el ancho según tus necesidades
            alignment: "left", // ajusta la alineación según tus necesidades
            margin: [0, 0, 0, 0], // Ancho de la imagen en el PDF
          },
          {
            text: fechaHora, // Agregar la fecha y hora con el formato deseado
            alignment: "left", // Alinear la fecha y hora a la derecha
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          {
            text: `FUERZA: ${this.valorCampo3}`, // Agregar la fecha y hora con el formato deseado
            alignment: "left", // Alinear la fecha y hora a la derecha
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          {
            text: `REPORTE PISTOLAS `,
            style: "header",
            fontSize: 10,
          },
          /* { text: "Datos obtenidos:", style: "subheader" }, */
          {
            table: {
              headerRows: 1,
              widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto", "*"],
              body: [
                [
                  {
                    text: "#",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                  {
                    text: "CODIGO ARMA",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                  {
                    text: "MARCA ARMA",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "MODELO ARMA",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                       {
                    text: "CODIGO CALIBRE",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "CANTIDAD CARGADORES",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "CODIGO PROCEDENCIA",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "CODIGO CLASIFICACION",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "OBSERVACIONES",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },


                ],
                ...pdfRows,
              ],
            },
            fontSize: 8,
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            table: {
              widths: ["*", "auto"],
              body: [
                [
                  {
                    text: "UNIDAD DE SISTEMAS E INFORMÁTICA GESTIÓN 2024",
                    fontSize: 8,
                    alignment: "left",
                  },
                  {
                    text: `Pag. ${currentPage}/${pageCount}`,
                    fontSize: 8,
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: "noBorders", // Para eliminar los bordes de la tabla
            margin: [40, 10], // Margen izquierdo y derecho para centrar la tabla
          };
        },
        styles: {
          header: {
            fontSize: 18,
            alignment: "center",
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: { fontSize: 16, bold: true, margin: [0, 10, 0, 5] },
        },
      };

      // Generar y abrir el PDF
      pdfMake.createPdf(documentDefinition).open();
    },
  },
});
</script>
